import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class BottlingApi {
  createBottling(payload) {
    return api.post(API_URLS.URL.bottling.createBottling, payload);
  }

  updateBottling(bottlingId, payload) {
    return api.put(
      API_URLS.URL.bottling.updateBottling?.replace(":id", bottlingId),
      payload,
    );
  }

  getBottlingList(payload) {
    return api.post(API_URLS.URL.bottling.getBottlingList, payload);
  }

  getBottlingSubList(payload) {
    return api.post(API_URLS.URL.bottling.getBottlingSubList, payload);
  }

  deleteBottleFromSubList(bottlingId) {
    return api.delete(
      API_URLS.URL.bottling.deleteBottleFromSubList?.replace(":id", bottlingId),
    );
  }
}
